import { pgTable, uuid, text, timestamp, index } from "drizzle-orm/pg-core";

// ---------------------------------------------------------------------------
// Status enum
// ---------------------------------------------------------------------------

export const A2P_REGISTRATION_STATUSES = [
  "pending_brand",
  "brand_approved",
  "brand_rejected",
  "pending_campaign",
  "campaign_approved",
  "campaign_rejected",
  "active",
] as const;

export type A2pRegistrationStatus = (typeof A2P_REGISTRATION_STATUSES)[number];

// ---------------------------------------------------------------------------
// Table
// ---------------------------------------------------------------------------

/** Tenant-level A2P 10DLC messaging registration (Twilio or other provider). */
export const tenantMessagingRegistrations = pgTable(
  "tenant_messaging_registrations",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    provider: text("provider").notNull().default("twilio"),
    twilioAccountSid: text("twilio_account_sid"),
    twilioBrandSid: text("twilio_brand_sid"),
    twilioCampaignSid: text("twilio_campaign_sid"),
    a2pRegistrationStatus: text("a2p_registration_status")
      .default("pending_brand")
      .notNull(),
    brandSubmittedAt: timestamp("brand_submitted_at", { withTimezone: true }),
    brandApprovedAt: timestamp("brand_approved_at", { withTimezone: true }),
    campaignSubmittedAt: timestamp("campaign_submitted_at", {
      withTimezone: true,
    }),
    campaignApprovedAt: timestamp("campaign_approved_at", {
      withTimezone: true,
    }),
    rejectionReason: text("rejection_reason"),
    createdAt: timestamp("created_at", { withTimezone: true })
      .defaultNow()
      .notNull(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
      .defaultNow()
      .notNull(),
  },
  (table) => [
    index("idx_messaging_reg_tenant").on(table.tenantId),
    index("idx_messaging_reg_status").on(table.a2pRegistrationStatus),
  ],
);
